import React from 'react'
import Header from '../components/Header'
import Hero from '../components/Hero'
import MainPresentation from '../components/MainPresentation'
import ContactCards from '../components/ContactCards'
import PartnerSection from '../components/PartnerSection'
import Footer from '../components/Footer'

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0b130e] text-[#f1f5f2] flex flex-col selection:bg-emerald-800 selection:text-emerald-100">
      <Header />
      <main className="flex-grow">
        <Hero />
        <MainPresentation />
        <ContactCards />
        <PartnerSection />
      </main>
      <Footer />
    </div>
  )
}
